import { render, staticRenderFns } from "./popupsImg.vue?vue&type=template&id=100aa16d&scoped=true"
import script from "./popupsImg.vue?vue&type=script&lang=js"
export * from "./popupsImg.vue?vue&type=script&lang=js"
import style0 from "./popupsImg.vue?vue&type=style&index=0&id=100aa16d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100aa16d",
  null
  
)

export default component.exports